module.exports = __webpack_public_path__ + "img/exord_snowman.907fa2f7.jpg";